export default "__VITE_ASSET__CXGJfEl6__"